import { useEffect, useState } from 'react';
const TS_DARK_MODE_UPDATE_MSG = 'TS_DARK_MODE_UPDATE';
function getIsDarkFromDOM() {
    if (typeof document === 'undefined')
        return false;
    return document.documentElement.getAttribute('data-theme') === 'dark';
}
export function useIsDarkMode() {
    const [isDark, setIsDark] = useState(getIsDarkFromDOM);
    useEffect(() => {
        const observer = new MutationObserver(() => setIsDark(getIsDarkFromDOM()));
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });
        setIsDark(getIsDarkFromDOM());
        return () => observer.disconnect();
    }, []);
    return isDark;
}
const CHART_TOKEN_VARS = {
    '--ts-var-viz-background': 'chart-surface',
    '--ts-var-viz-border-color': 'chart-border',
    '--ts-var-chart-data-label-stroke-color': 'chart-data-label-halo',
    '--ts-var-chart-grid-line-color': 'chart-gridline',
    '--x-axis-gridlines-stroke': 'chart-gridline',
    '--y-axis-gridlines-stroke': 'chart-gridline',
    '--tick-line-color': 'chart-axis-line',
    '--x-axis-intervals-color': 'chart-axis-line',
    '--y-axis-intervals-color': 'chart-axis-line',
    '--zero-line-color-x': 'chart-axis-line',
    '--zero-line-color-y': 'chart-axis-line',
    '--ts-var-axis-data-label-color': 'chart-axis-label',
    '--ts-var-axis-title-color': 'chart-axis-label',
    '--ts-var-viz-facet-label-color': 'chart-label',
    '--ts-var-viz-legend-text-color': 'chart-label',
    '--ts-var-viz-legend-title-color': 'chart-label',
    '--ts-var-viz-legend-swatch-border-color': 'chart-legend-swatch-border',
    '--ts-var-chart-tooltip-bg-color': 'chart-tooltip-surface',
    '--ts-var-chart-tooltip-text-color': 'chart-tooltip-text',
    '--ts-var-chart-tooltip-shadow': 'chart-tooltip-shadow',
    '--ts-var-chart-btn-bg-color': 'chart-control-surface',
    '--ts-var-chart-btn-hover-bg-color': 'chart-control-surface-hover',
    '--ts-var-chart-btn-icon-color': 'chart-control-icon',
    '--ts-var-chart-scroll-bar-bg-color': 'chart-control-surface',
    '--ts-var-chart-scroll-track-bg-color': 'chart-scrollbar-track',
    '--chart-table-striped-row-color': 'chart-table-striped-row',
};
const PASSTHROUGH_TOKEN_VARS = [
    '--rd-sys-color-content-primary',
    '--rd-sys-color-border-subtle',
    '--rd-comp-color-chip-attribute-default',
    '--rd-comp-color-chip-measure-default',
    '--rd-comp-color-chip-date-default',
    '--rd-comp-color-chip-error-default',
];
export function getChartThemeCssVars() {
    const rootStyle = getComputedStyle(document.documentElement);
    const cssVars = {};
    Object.entries(CHART_TOKEN_VARS).forEach(([cssVar, token]) => {
        cssVars[cssVar] = rootStyle.getPropertyValue(`--rd-comp-color-${token}`).trim();
    });
    PASSTHROUGH_TOKEN_VARS.forEach(cssVar => {
        cssVars[cssVar] = rootStyle.getPropertyValue(cssVar).trim();
    });
    return cssVars;
}
export function postDarkModeUpdate(iframeWindow, isDarkMode) {
    if (!iframeWindow)
        return;
    iframeWindow.postMessage({
        type: TS_DARK_MODE_UPDATE_MSG,
        isDarkMode,
        cssVars: getChartThemeCssVars(),
    }, '*');
}
//# sourceMappingURL=dark-mode.util.js.map